import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList, Cell } from 'recharts';


const colors = {
  "Round 1 -> 2": "#33ABDA",
  "Round 2 -> 3": "#B05788",
  "Round 3 -> 4": "#0078A7",
  "Round 4 -> 5": "#8458CC",
  "Round 5 -> 6": "#3A3A3A",
  "Round 6 -> 7": "#994900",

}

const keyMapping = {
  "Round 1 -> 2": "round1To2",
  "Round 2 -> 3": "round2To3",
  "Round 3 -> 4": "round3To4",
  "Round 4 -> 5": "round4To5",
  "Round 5 -> 6": "round5To6",
  "Round 6 -> 7": "round6To7",

}
const calculateMinValue = (data, keys) => {
  if (!Array.isArray(data)) return 0; 
  return Math.min(
    ...data.map((item) => 
      Math.min(
        ...keys.map((key) => {
          const value = parseFloat(item[key]);
          return isNaN(value) ? Infinity : value;
        })
      )
    )
  );
};
const calculateMaxValue = (data, keys) => {
  if (!Array.isArray(data)) return 0;
  return Math.max(
    ...data.map((item) => 
      Math.max(
        ...keys.map((key) => {
          const value = parseFloat(item[key]); 
          return isNaN(value) ? 0 : value;
        })
      )
    )
  );
};

// const generateTicks = (minValue,maxValue) => {
//   const step = Math.abs(minValue) / 5;
//   return [...Array(6)].map((_, i) => 0 - i * step);
// };

// const generateTicks = (minValue, maxValue) => {
//   console.log(minValue, maxValue)
//   const maxAbs = Math.max(Math.abs(minValue), Math.abs(maxValue));
//   const step = maxAbs / 5; // Ensure equal spacing
  
//   return [...Array(11)].map((_, i) => (i - 5) * step);
// };
const generateTicks = (min, max) => {
  const ticks = new Set();
  if (min <= 0 && max >= 0) {
    ticks.add(0);
  }
  const interval = (max - min) / 4;
  for (let i = 0; i < 5; i++) {
    ticks.add(parseFloat((min + i * interval).toFixed(2)));
  }

  return Array.from(ticks).sort((a, b) => a - b);
};

const PriceChangeBarChart = ({ averagePriceChangeDto }) => {
  const roundUpToNearest5 = (value) => Math.floor(value / 5) * 5;
  const roundUpToNearest5Positive = (value) => Math.ceil(value / 5) * 5;
  const filteredObj = Object.fromEntries(
    Object.entries(averagePriceChangeDto).filter(([key, value]) => value !== null)
  );
  // const data = Object.keys(colors).map(key => ({
  //   name: key,
  //   value: parseFloat(filteredObj?.[keyMapping[key]]),
  //   color: colors[key]
  // }));
  const data = Object.entries(filteredObj).map(([key, value]) => {
    const displayName = Object.keys(keyMapping).find((k) => keyMapping[k] === key);

    return {
      name: displayName,
      value: parseFloat(value),
      color: colors[displayName],
    };
  });

//  const maxValue = roundUpToNearest5Positive(calculateMaxValue(data, ['value']))<0?0:roundUpToNearest5Positive(calculateMaxValue(data, ['value'])); 
//  const minValue = roundUpToNearest5(calculateMinValue(data, ['value']));

  const maxValue = (calculateMaxValue(data, ['value']))<0?0:(calculateMaxValue(data, ['value'])); 
  const minValue = (calculateMinValue(data, ['value']));
  // console.log(generateTicks(minValue, maxValue))
  return (
    // <div style={{ width: "100%", height: "200px", overflowY: "auto" }}>
    //   <div style={{ width: '100%', height: `${data.length * 200}px` }}>
    //     <ResponsiveContainer width="100%" height={'100%'} >
        <ResponsiveContainer width="100%" height={300} >
          <BarChart data={data} margin={{ top: 30, right: 20, left: 20, bottom: 20 }}>
            <CartesianGrid horizontal={true} vertical={false} stroke='#DFDFDF' />
            <XAxis dataKey="name" tickLine={false} axisLine={false} tick={false} />
            <YAxis axisLine={false} tickLine={false} 
              ticks={generateTicks(minValue, maxValue)}
              domain={[minValue, maxValue]} 
              allowDecimals={false} interval={0}/>
            {/* domain={[0, 'auto']} */}
            {/* fill="#0078A7" allowDataOverflow={true}*/} 
            <Bar dataKey="value" barSize={40}>
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
              <LabelList dataKey="value" position="top" offset={10} fill="#616161" />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
    //   </div>
    // </div>
  );
};

export default PriceChangeBarChart;
